import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { truncate } from 'lodash';
import { Collapse } from 'react-bootstrap';
import NumberDisplay from '../number-display';
import styles from './styles.css';
import Avatar from '../avatar';

class TeamMemberNode extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
    };
    this.open = this.open.bind(this);
  }

  open(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ open: !this.state.open });
  }

  render() {
    const {
      node,
      indexedOwners,
      isRoot,
      level,
      isMyTeam,
    } = this.props;
    const isOwnerNode = node.owner_id !== null && node.owner_id !== undefined;
    const nodes = isOwnerNode ? node.teams || [] : node.members || [];
    const user = indexedOwners[node.owner_id];
    const userName = isOwnerNode && user ? user.name || `${user.first_name} ${user.last_name}` : node.name;

    const displayName = isOwnerNode && user ? <span>{userName}</span> : <span className="text-uppercase">{truncate(userName || node._id, { length: 30 })}</span>;
    
    const hasMembers = nodes.length > 0;

    const shouldOpen = isRoot || this.state.open;
    const avatar = isOwnerNode ? <Avatar className={styles.tagAvatar} size={22} user={user} /> : <span>&nbsp;<Fa name="users" />&nbsp;</span>;
    const suffix = isOwnerNode && hasMembers ? <span className="badge"><NumberDisplay value={nodes.length} precision={0} suffix="team" suffixIsUnit /></span> : null;

    const cls = [styles.teamMeberNode];
    if (hasMembers) {
      cls.push(styles.hasMembers);
    }

    if (this.state.open) {
      cls.push(styles.open);
    }
    return (
      <div>
        {!isRoot &&
          <div className={cls.join(' ')}>
            {hasMembers &&
              <div>
                <a
                  href=""
                  onClick={this.open}
                >
                  {avatar} {displayName} {suffix}
                </a>
              </div>
            }
            {!hasMembers &&
              <div>
                {avatar} {displayName}
              </div>
            }
          </div>
        }
        {nodes.length > 0 &&
          <Collapse in={shouldOpen}>
            <ul className={styles.teamMemberList}>
              {nodes.map(member => (
                <li key={member._id}>
                  <TeamMemberNode
                    node={member}
                    isRoot={false}
                    isMyTeam={isMyTeam}
                    level={(level + 1)}
                    indexedOwners={indexedOwners}
                  />
                </li>
              ))}
            </ul>
          </Collapse>
        }
      </div>
    );
  }
}

TeamMemberNode.propTypes = {
  node: PropTypes.shape({}),
  indexedOwners: PropTypes.shape({}),
  isRoot: PropTypes.bool,
  isMyTeam: PropTypes.bool,
  level: PropTypes.number,
};
TeamMemberNode.defaultProps = {
  node: {},
  isRoot: false,
  isMyTeam: false,
  indexedOwners: {},
  level: 1,
};
export default TeamMemberNode;
